import { defineStore } from 'pinia'

export const useSocialMedia = defineStore('componentStore', {
  id: 'socialMedia',
  state: () => ({
    stateSelectedHashtags: [],
    stateSelectedTopInfluencers: [],
    stateSelectedTouristAttractions: [],
  }),
  getters: {
    selectedHashtags(state) {
      return state.stateSelectedHashtags
    },
    selectedTopInfluencers(state) {
      return state.stateSelectedTopInfluencers
    },
    selectedTouristAttractions(state) {
      return state.stateSelectedTouristAttractions
    },
  },
  actions: {
    getSelectedHashtags(selectedHashtags) {
      this.stateSelectedHashtags = selectedHashtags
    },
    getTopInfluencers(topInfluencers) {
      this.stateSelectedTopInfluencers = topInfluencers
    },
    getTouristAttractions(touristAttractions) {
      this.stateSelectedTouristAttractions = touristAttractions
    },
  },
})
